import axios from "axios";
import ProductCard from "./ProductCard";
const getCartDialog = () => document.querySelector('.cartDialog');

export const openMiniCart = () => {
    const cartDialog = getCartDialog();
    if (!cartDialog) return;

    setTimeout(() => cartDialog.showModal(), 1500);
    document.body.classList.add('body--no-scroll');
};

export const closeMiniCart = () => {
    const cartDialog = getCartDialog();
    if (!cartDialog) return;

    const closeButton = cartDialog.querySelector('.close');
    closeButton?.addEventListener('click', () => {
        cartDialog.close();
        document.body.classList.remove('body--no-scroll');
    });
};

export const initMiniCartCloseOutside = () => {
    const cartDialog = getCartDialog();
    if (!cartDialog) return;

    cartDialog.addEventListener('click', (event) => {
        let rect = event.target.getBoundingClientRect();
        if (rect.left > event.clientX ||
            rect.right < event.clientX ||
            rect.top > event.clientY ||
            rect.bottom < event.clientY
        ) {
            cartDialog.close();
            document.body.classList.remove('body--no-scroll');
        }
    });
}

export const headerCartOpen = () => {
    document.addEventListener('click', (event) => {
        const cartTrigger = event.target.closest('#cart-trigger');
        const cartDialog = getCartDialog();
        if (cartTrigger && cartDialog) {
            cartDialog.showModal();
            document.body.classList.add('body--no-scroll');
        }
    });

    jQuery(document.body).on('wc_fragments_loaded', () => {
        ProductCard(getCartDialog());
    });
};

export const headerCartContinue = () => {
    document.addEventListener('click', (event) => {
        const cartContinue = event.target.closest('.cartDialog__countinue');
        const cartDialog = getCartDialog();
        if (cartContinue && cartDialog) {
            cartDialog.close();
        }
    });
};

export const miniCartQtyChange = () => {
    (function ($) {
        $(document).on('click', '.plus', function () {
            let input = $(this).siblings('.mini-cart-quantity-input');
            let newValue = parseInt(input.val()) + 1;
            input.val(newValue).change();
        });

        $(document).on('click', '.minus', function () {
            let input = $(this).siblings('.mini-cart-quantity-input');
            let newValue = parseInt(input.val()) - 1;
            if (newValue >= 0) {
                input.val(newValue).change();
            }
        });

        $(document).on('change', '.mini-cart-quantity-input', function () {
            const loading = document.querySelector('.cartDialog__wrapper');
            let cart_item_key = $(this).data('cart_item_key');
            let quantity = $(this).val();
            loading.classList.add('loading');

            const data = new URLSearchParams();
            data.append('action', 'woocommerce_update_cart_quantity');
            data.append('cart_item_key', cart_item_key);
            data.append('quantity', quantity);
            axios.post('/wp-admin/admin-ajax.php', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                }
            }).then(res => {
                if (res.data.success) {
                    $('.widget_shopping_cart_content').html(res.data.data.mini_cart);
                    $.each(res.data.data.fragments, function (selector, html) {
                        $(selector).replaceWith(html);
                    });

                } else {
                    alert(res.data.message);
                }
                loading.classList.remove('loading');
            }).catch(err => {
                console.error('An error occurred:', err);
                loading.classList.remove('loading');
            }).finally(() => {
                jQuery(document.body).trigger('wc_fragments_loaded');
            });

        });
    })(jQuery);
};
